import React from "react";

const SkeletonProfile = () => {
  return (
    <div style={{ paddingTop: "1.5rem" }}>
      {/* Header row */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2rem" }}>
        <div className="skeleton" style={{ width: 80, height: 34, borderRadius: 6 }} />
        <div className="skeleton" style={{ width: 120, height: 28, borderRadius: 24 }} />
      </div>

      {/* Profile card */}
      <div className="skeleton-profile-card">
        <div className="skeleton-profile-grid">
          <div className="skeleton-profile-avatar">
            <div
              className="skeleton skeleton-circle"
              style={{ width: 160, height: 160 }}
            />
            <div className="skeleton" style={{ width: 120, height: 20 }} />
            <div className="skeleton" style={{ width: 80, height: 14 }} />
          </div>
          <div className="skeleton-profile-details">
            <div className="skeleton" style={{ width: 40, height: 12 }} />
            <div className="skeleton" style={{ width: "90%", height: 14 }} />
            <div className="skeleton" style={{ width: "70%", height: 14 }} />
            <div
              className="skeleton"
              style={{ width: 160, height: 36, borderRadius: 6, marginTop: "0.5rem" }}
            />
            <div className="skeleton" style={{ width: "50%", height: 14, marginTop: "0.75rem" }} />
            <div className="skeleton" style={{ width: "40%", height: 14 }} />
            <div className="skeleton" style={{ width: "45%", height: 14 }} />
          </div>
        </div>
      </div>

      {/* Stats row */}
      <div className="skeleton-stats-row">
        {[0, 1, 2, 3].map((i) => (
          <div className="skeleton-stat" key={i}>
            <div className="skeleton" style={{ width: 40, height: 24 }} />
            <div className="skeleton" style={{ width: 60, height: 10 }} />
          </div>
        ))}
      </div>

      {/* Repos */}
      <div>
        <div
          className="skeleton"
          style={{ width: 140, height: 14, marginBottom: "1rem" }}
        />
        <div className="repo-grid">
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <div className="skeleton-repo-card" key={i}>
              <div style={{ display: "flex", alignItems: "center", gap: "0.6rem", marginBottom: "0.6rem" }}>
                <div className="skeleton" style={{ width: 14, height: 14 }} />
                <div className="skeleton" style={{ width: `${50 + i * 5}%`, height: 14 }} />
              </div>
              <div className="skeleton" style={{ width: "90%", height: 12, marginBottom: "0.4rem" }} />
              <div className="skeleton" style={{ width: "60%", height: 12, marginBottom: "0.75rem" }} />
              <div style={{ display: "flex", gap: "1rem", borderTop: "1px solid var(--border-color)", paddingTop: "0.5rem" }}>
                <div className="skeleton" style={{ width: 40, height: 10 }} />
                <div className="skeleton" style={{ width: 30, height: 10 }} />
                <div className="skeleton" style={{ width: 50, height: 10 }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkeletonProfile;
